import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import logo from "../assets/logo.png";

export default function HomeBanner2(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-surface"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				
				<div 
					className="container"
					
				>
					
				
					<div className="row">

						<div className="col-md-12">
							
							<h1
								style={{
									fontSize: "22px",
								}}
								className="font-light text-center"
							>
								<img src={logo} height={250}/>
								<br/>

								Boston Unique Services Limited is a premium systems company 
								that was founded in the year 2010 and incorporated in the year 
								2023 in the United Republic of Tanzania. For the last 12 years, the 
								foudners and key stakeholders of Boston Unique Services were 
								working with <strong>ENCAPSULATED EAST AFRICA LIMITED</strong><br/>  
								a world-class company incorporated in the Republic of Kenya. 
								<br />
								<br />
								The stakeholders of Encapsulated East Africa Limited and Boston 
								Unique Services covenanted to extend services to the United 
								Republic of Tanzania in an outfit of Boston Unique services.
							</h1>

							<div className="text-center mt-5">
								<button
									className="btn btn-padded btn-secondary"
									onClick={() => {
										appContext.navTo({
											item: 'about_us'
										})
									}}
								>
									Learn More...
								</button>
							</div>

						</div>


						

						
					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
